export default function Security() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10">
      <h1 className="text-2xl font-bold mb-6">Security</h1>
      <div className="space-y-4 text-slate-700">
        <p>
          L'accesso alla piattaforma avviene tramite connessioni cifrate TLS e misure di protezione progettate per ridurre i rischi di accesso non autorizzato.
        </p>
        <p>
          I dati vengono trattati con misure tecniche e organizzative adeguate, inclusi controlli sugli accessi, gestione delle sessioni e procedure di backup.
        </p>
        <p>
          Per segnalazioni di sicurezza o richieste tecniche e possibile contattare il supporto dedicato.
        </p>
      </div>
    </div>
  );
}
